'use client'
import { useHeaderState } from './HeaderContext'
import { Icons } from '../Icon/constants'
import Icon from '../Icon/Icon'

export function MainNavigationDrawerToggleBtn(props: {
  className?: string
  classes?: {
    root?: string
    icon?: string
  }
}) {
  const [headerState, setHeaderState] = useHeaderState()
  return (
    <button
      className={props.classes?.root || props.className || 'leading-none size-6 p-0'}
      onClick={(ev) => {
        ev.preventDefault()
        if (headerState.isTransitioning.current) return
        setHeaderState((prevState) => ({ ...prevState, isOpen: !prevState.isOpen }))
      }}>
      <Icon
        className={props.classes?.icon || 'size-6'}
        iconName={headerState.isOpen ? Icons.CLOSE : Icons.MENU}
      />
    </button>
  )
}
